import * as React from 'react'

import Svg, { Path } from 'react-native-svg'

import { IconProps } from '..'

const Send = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    xmlns="http://www.w3.org/2000/svg"
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <Path
      d="M20.3 10.87L5.12 3.47a.998.998 0 00-.42-.1.96.96 0 00-.96.96v.03c0 .13.02.26.05.38l1.46 5.82c.04.16.17.28.34.29l6.4.71c.22.02.39.21.39.44s-.17.41-.39.44l-6.4.71a.41.41 0 00-.34.29l-1.46 5.82c-.03.12-.05.25-.05.38v.03c0 .53.43.96.96.96.15 0 .29-.03.42-.1l15.17-7.4c.43-.21.7-.65.7-1.13 0-.48-.27-.92-.7-1.13h.01z"
      fill={color}
    />
  </Svg>
)

export default Send
